<app-navigator [navigator]="navigator"></app-navigator>
<hr>
<ng-container *ngIf='utente; else waiting'>
    <ngb-toast *ngIf="toastConfig" [autohide]="true" [delay]="3000" (hidden)="toastConfig = undefined"
        [ngClass]="toastConfig.class">
        <container-element [ngSwitch]="toastConfig.class">
            <img *ngSwitchCase="'success'" src="assets/icone_varie/ok.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'warning'" src="assets/icone_varie/danger.svg" style="width: 20px; margin-right: 5px;">
            <img *ngSwitchCase="'error'" src="assets/icone_varie/error.svg" style="width: 20px; margin-right: 5px;">
        </container-element>

        {{toastConfig.title}}
    </ngb-toast>
    <div class="actionBar">

        <ng-container *ngIf='id !="new"; else _new'>
            <h5 class="roboSubTitle col">{{utente.email}}<br *ngIf="innerWidth! <= 767"></h5>
            <!--<ng-container *ngIf="utente.is_active == 'f'">
                <button *ngIf="utente.is_active == 'f'" type="submit" class="btn btn-danger" style="margin-left: 10px;"
                    (click)="nascondiUtente()"><i class="bi bi-eye-slash" style="margin-right:5px"></i>NASCONDI
                    UTENTE</button>
                <button *ngIf="utente.abilitato==3" type="submit" class="btn btn-success"
                    style="margin-left: 10px;" (click)="mostraUtente()"><i class="bi bi-eye"
                        style="margin-right:5px"></i> RENDI VISIBILE</button>
            </ng-container>-->
            <button type="submit" class="btn btn-primary" style="margin-left: 10px;" (click)="setSessionUser()"
                [routerLink]="['../../invoices']">{{ 'sidebar.fatture' | translate }}</button>
            <button type="submit" class="btn btn-primary" style="margin-left: 10px;" (click)="setSessionUser()"
                [routerLink]="['../../configuration', utente.id]">{{ 'configuration.tabs.rubrica' | translate
                }}</button>
            <button type="submit" class="btn btn-primary" style="margin-left: 10px;" (click)='save()'>{{ 'general.save'
                | translate }}</button>
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>
                    <i class="bi bi-three-dots" style="width: 25px;"></i>

                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button *ngIf="me!.role == 'A'" ngbDropdownItem (click)="enable()">{{ (utente.abilitato==0?
                        'general.enable' : 'general.disable') | translate }}</button>
                    <!-- DISABILITATA CANCELLAZIONE UTENTE -->
                    <button ngbDropdownItem (click)="deleteUser()">{{ 'general.delete' | translate }}</button>
                </div>
            </div>
        </ng-container>
        <ng-template #_new>
            <h5 class="roboSubTitle col">{{ 'general.newUser' | translate }}<br *ngIf="innerWidth! <= 767"></h5>

            <button type="submit" class="btn btn-primary" style="margin-left: 10px;" (click)='save()'>{{ 'general.save'
                | translate }}</button>
        </ng-template>

    </div>
    <hr>
    <!--<div class="row mb-3">
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             RUOLO (PER IL MOMENTO POTREMMO LASCIARE TUTTI UTENTI NORMALI)

            <label class="roboSubTitle" [ngClass]="utente.role=='' ?'colorRed': ''">{{ 'users.editor.role' |
                translate }}</label>

            <app-select class="selectDm7" *ngIf="!(me!.role != 'A' && me!.role != 'S')" [options]="roles" [key]="'code'"
                [value]="'name'" [placeholder]="'placeholder.select' | translate" [addNull]="false"
                [selectedKey]="utente.role" (change)="utente.role = $event.key; eventChangeRole($event.key)"
                [valClass]="utente.role=='' ?'borderRed': ''"></app-select>
            <input *ngIf="(me!.role != 'A' && me!.role != 'S')" [readonly]="true" type="text" class="form-control"
                type="text" value="{{'users.personal.utilizzatore' | translate}}">
        </div>

        <div *ngIf="(utente.role=='U' || utente.role=='R') && me!.role == 'S'"
            [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             AMMINISTRATORE SE UTENTE È UTILIZZATORE 
            <label class="roboSubTitle">{{ 'users.editor.admin' | translate }}</label>
            <app-select class="selectDm7" [options]="admins" [key]="'dms_user_id'" [value]="'username'"
                [disabled]="utente.id_utente_admin != ''" [placeholder]="'placeholder.select' | translate"
                [addNull]="true" [selectedKey]="utente.id_utente_admin"
                (change)="utente.id_utente_admin = $event.key; eventChandgeAdmin($event.key)"></app-select>
        </div>

        <div *ngIf="utente.role=='U' && me!.role != 'R' && utente.id_utente_admin != ''"
            [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             RIVENDITORE SE UTENTE È UTILIZZATORE 
            <label class="roboSubTitle">{{ 'users.editor.reseller' | translate }}</label>
            <app-select class="selectDm7" [options]="resellers" [key]="'dms_user_id'"
                [disabled]="utente.id_utente_reseller != ''" [value]="'denominazione'"
                [placeholder]="'placeholder.select' | translate" [addNull]="false"
                [selectedKey]="utente.id_utente_reseller"
                (change)="utente.id_utente_reseller = $event.key;"></app-select>
        </div>
    </div>-->
    <div class="row">
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <!-- USERNAME  -->
            <label class="roboSubTitle" [ngClass]="utente.email == '' ? 'colorRed' : ''">Username/E-mail</label>
            <input class="form-control" type="text" [ngbTooltip]="'users.personal.tooltipUsername' | translate"
                [(ngModel)]="utente.email" readonly [ngClass]="utente.email=='' ? 'borderRed' : ''">
        </div>
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
            <!-- TIPOLOGIA CLIENTE  -->
            <label class="roboSubTitle">Tipologia cliente</label>
            <input class="form-control" type="text" [(ngModel)]="utente.invoices_purchased" readonly>
        </div>
        <div *ngIf="utente.invoices_purchased != 'PREMIUM'" [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             <!-- LIMITE FATTURE --> 
            <label class="roboSubTitle">Fatture rimanenti</label>
            <input class="form-control" type="number" min="0" [(ngModel)]="utente.invoices_remaining">
        </div>
        <!--<div [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             LIMITE DDT  
            <label class="roboSubTitle">{{ 'users.editor.DDTLim' | translate }}</label>
            <input class="form-control" type="number" min="0" [(ngModel)]="utente.limite_ddt">
        </div>-->
        <!--<div *ngIf='(me!.role=="A" || me!.role=="S") && utente.role=="R" '
            [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             LIMITE UTENZE ATTIVABILI  
            <label class="roboSubTitle">{{ 'users.editor.usersLim' | translate }}</label>
            <input class="form-control" type="number" min="0" [(ngModel)]="utente.limite_utenti_gestiti">
        </div>-->
        <div [ngClass]="{'col-1' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
            [ngStyle]="{'padding-left': innerWidth! <= 767 ? 0 : 15 + 'px'}">
            <label class="roboSubTitle">{{(utente.is_active == 't' ? 'users.editor.enabled' :
                'users.editor.noEnabled') | translate}}</label>
            <img [src]="'assets/icone_varie/' + (utente.is_active == 't' ? 'cerchio_check.svg' : 'error.svg')"
                style="width:30px; height: auto; padding : 5px">

        </div>

        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767}">
            <div class="btnWithLabel" [ngStyle]="{'padding-left': innerWidth! <= 767 ? 0 : 15 + 'px'}">
                <label for="btnPass" class="roboSubTitle">Password:</label>
                <button *ngIf="id != 'new'" id="btnPass" class="btn btn-primary col-auto"
                    (click)="resetPassword()">{{'users.editor.resetPassword' | translate}}</button>
                <ngb-toast *ngIf="id == 'new'" [autohide]="false" class="default">
                    {{'users.editor.passwordAuto' | translate}}
                </ngb-toast>
            </div>
        </div>

        <div [ngClass]="{'col-1' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
            [ngStyle]="{'padding-left': innerWidth! <= 767 ? 0 : 15 + 'px'}">
            <label class="roboSubTitle">Logo</label>
            <div class="d-flex align-items-end">
                <button type="button" class="btn btn-primary" (click)="openLogoModal(logoModal)">Carica</button>
                <img [src]="'assets/icone_varie/' + ((utente.img_logo_path != '') ? 'cerchio_check.svg' : 'error.svg')"
                    style="width:30px; height: auto; padding : 5px" [ngbTooltip]="((utente.img_logo_path != '') ? 'Configurato' : 'Non configurato')">
            </div>
        </div>

    </div>
    <div class="row">
        <!--<div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             EMAIL  
            <label class="roboSubTitle" [ngClass]="utente.email=='' ? 'colorRed' : ''">Email</label>
            <input class="form-control" [ngbTooltip]="'users.editor.tooltip1' | translate" type="email"
                [(ngModel)]="utente.email" [ngClass]="utente.email=='' ? 'borderRed' : ''">
        </div>-->
        <!-- NOTIFICHE FATT -->
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <div class="btnWithLabel">
                <!--<input type="checkbox" class="form-check-input" [(ngModel)]="utente.abilita_mail">-->
                <label class="roboSubTitle" >{{'users.editor.notifiche_fatt' | translate}}</label>
            </div>
            <div class="btn-group px-2">
                <button type="button" [ngClass]="(notifiche.RC ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('RC');" [ngbTooltip]="'Ricevi notifiche di ricevuta di consegna'"
                    class="btn btn-success mx-1">RC</button>
                <button type="button" [ngClass]="(notifiche.MC ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('MC');" [ngbTooltip]="'Ricevi notifiche di mancata consegna'"
                    class="btn btn-success mx-1">MC</button>
                <button type="button" [ngClass]="(notifiche.NS ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('NS');" [ngbTooltip]="'Ricevi notifiche di scarto'"
                    class="btn btn-success mx-1">NS</button>
                <button type="button" [ngClass]="(notifiche.NE ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('NE');" [ngbTooltip]="'Ricevi notifiche di esito PA'"
                    class="btn btn-success mx-1">NE</button>
                <button type="button" [ngClass]="(notifiche.DT ? 'btn btn-success' : 'btn btn-danger')"
                    (click)="setNotifica('DT');" [ngbTooltip]="'Ricevi notifiche di decorrenza termini'"
                    class="btn btn-success mx-1">DT</button>
            </div>
        </div>

        <div class="form-group form-check col-4" style="margin-bottom: 5px; margin-top:20px">
            <label class="roboSubTitle">Email per ricezione notifiche</label>
            <div class="d-flex align-items-end">
                <input class="form-control" type="text" [(ngModel)]="notifiche.mailNotifiche">
                <button type="button" class="btn btn-success ms-2" (click)="setNotifica('');">Salva</button>
            </div>
            
        </div>

        <div class="form-group form-check col-4" style="margin-bottom: 5px; margin-top:20px">
            <label class="roboSubTitle">Canali notifiche push</label>
            <div class="d-flex align-items-end">
                <button type="button" class="btn btn-primary" (click)="openNotificheModal(notificheModal)">Configura</button>
                <img [src]="'assets/icone_varie/' + ((notifiche.push != '' && notifiche.token != '') ? 'cerchio_check.svg' : 'error.svg')"
                    style="width:30px; height: auto; padding : 5px" [ngbTooltip]="((notifiche.push != '' && notifiche.token != '') ? 'Configurato' : 'Non configurato')">
            </div>
        </div>

        
        <!-- NOTIFICHE ORDINI 
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
            class="form-group form-check" style="margin-bottom: 5px;">
            <div class="userCheckBox">
                <input type="checkbox" class="form-check-input" [(ngModel)]="utente.abilita_mail_ordini">
                <label class="form-check-label" for="securOrder">{{'users.editor.notifiche_ord' | translate}}</label>
            </div>
        </div>-->
    </div>

    <ng-template #notificheModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title roboTitle">Configura notifiche push</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
                <label class="roboSubTitle">Url per notifiche push</label>
                <input class="form-control" type="text" [(ngModel)]="notificheDraft.push">
            </div>
            <div class="mb-3">
                <label class="roboSubTitle">Token di autenticazione</label>
                <input class="form-control" type="text" [(ngModel)]="notificheDraft.token">
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Annulla</button>
            <button type="button" class="btn btn-success" (click)="saveNotificheModal(modal)">Salva</button>
        </div>
    </ng-template>

    <ng-template #logoModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title roboTitle">Carica logo</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>
        <div class="modal-body">
            <div (click)="fileInput.click()" class="w-20 h-20 overflow-hidden border border-gray-200 rounded-full dark:border-gray-800">
              <img [src]="logoSafeUrl" alt="logo" />
              <input type="file" #fileInput style="display: none" accept="image/jpeg, image/png, image/webp" (change)="salvaLogoAzienda($event, modal)">
            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Annulla</button>
        </div>
    </ng-template>

    <hr>
    <h3 class="roboSubTitle col">Dati anagrafici<br *ngIf="innerWidth! <= 767"></h3>
    <div class="row">
        <div [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Denominazione -->
            <label class="roboSubTitle">Denominazione</label>
            <input class="form-control" type="text" [(ngModel)]="utente.denominazione">
        </div>
    </div>
    <div class="row">
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Partita IVA -->
            <label class="roboSubTitle">Partita IVA</label>
            <input class="form-control" type="text" [(ngModel)]="utente.partita_iva">
        </div>
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Codice Fiscale -->
            <label class="roboSubTitle">Codice Fiscale</label>
            <input class="form-control" type="text" [(ngModel)]="utente.codice_fiscale">
        </div>
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Regime Fiscale -->
            <label class="roboSubTitle">Regime Fiscale</label>
            <app-select class="selectDm7" 
                [options]="regimi" [key]="'val'" [value]="'label'"
                [placeholder]="'placeholder.select' | translate" [addNull]="false" [selectedKey]="utente!.regime_fiscale"
                (change)="utente!.regime_fiscale= $event.key;" [valClass]="utente!.regime_fiscale == '' ? 'borderRed' : ''"></app-select>
        </div>
    </div>
    <div class="row">
        <div [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Indirizzo -->
            <label class="roboSubTitle">Indirizzo</label>
            <input class="form-control" type="text" [(ngModel)]="utente.indirizzo">
        </div>
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- CAP -->
            <label class="roboSubTitle">CAP</label>
            <input class="form-control" type="text" [(ngModel)]="utente.cap">
        </div>
    </div>
    <div class="row">
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Comune -->
            <label class="roboSubTitle">Comune</label>
            <input class="form-control" type="text" [(ngModel)]="utente.comune">
        </div>
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Provincia -->
            <label class="roboSubTitle">Provincia</label>
            <input class="form-control" type="text" maxlength="2" [(ngModel)]="utente.provincia">
        </div>
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- Nazione -->
            <label class="roboSubTitle">Nazione</label>
            <input class="form-control" type="text" maxlength="2" [(ngModel)]="utente.nazione">
        </div>
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">
            <!-- IBAN -->
            <label class="roboSubTitle">IBAN</label>
            <input class="form-control" type="text" [(ngModel)]="utente.iban_list">
        </div>
    </div>

    <hr *ngIf="me?.role == '3'">
    <h3 class="roboSubTitle col" *ngIf="me?.role == '3'">Servizi abilitati</h3>

    <div class="row" *ngIf="me?.role == '3'">    
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">            
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" [(ngModel)]="serviceFatturazione" (change)="cambiaFatturazione()">
                <label class="form-check-label roboSubTitle ms-2">Fatturazione</label>
            </div>
        </div>

        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">            
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" [(ngModel)]="serviceArchOptima" (change)="cambiaArchOptima()">
                <label class="form-check-label roboSubTitle ms-2">ArchOptima</label>
            </div>
        </div>

        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">            
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" [(ngModel)]="serviceTimbrature" (change)="cambiaTimbrature()">
                <label class="form-check-label roboSubTitle ms-2">Timbrature</label>
            </div>
        </div>

        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}" style="margin-bottom: 5px; margin-top:20px">            
            <div class="form-check">
                <input class="form-check-input" type="checkbox" value="" [(ngModel)]="serviceISO" (change)="cambiaConsulenzaISO()">
                <label class="form-check-label roboSubTitle ms-2">Consulenza ISO</label>
            </div>
        </div>
    </div>
    
    
    <!--<div class="row" style="margin-top:20px">
        <div class="actionBar">
            <h5 class="roboSubTitle col" style="margin-top: 20px; margin-bottom: -20px;">{{ 'users.editor.invoicesTitle' |
                translate }}<br *ngIf="innerWidth! <= 767"></h5>
            <div class="custom-control custom-switch col-6 col-md-4 text-right" *ngIf="me!.role =='A' || me!.role == 'S' ">
                <input type="checkbox" [checked]="utente.codice_univoco == '' && utente.email_pec == ''"
                    (click)="disabilitaFatturazionePassiva()" class="custom-control-input">
                <label class="custom-control-label" for="">{{ 'users.editor.disable_passive' | translate}}</label>
            </div>
        </div>
    </div>

    <div class="row">
        <ng-container *ngIf="utente.id !='' && (me!.role =='A' || me!.role=='S')">
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 SELECT MODALITÀ RICEZIONE FATTURE PASSIVE 
                <label class="roboSubTitle">{{ 'users.editor.receivingMode' | translate }}</label>

                <app-select class="selectDm7" [options]="recWays" [key]="'key'" [value]="'value'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="true"
                    [selectedKey]="utente.mod_ric_fp"
                    (change)="utente.mod_ric_fp = $event.key;setCodiceUnivoco()"></app-select>
            </div>
        </ng-container>-->

        <!--<ng-container *ngIf='utente.id ==""'>
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 SELECT MODALITÀ RICEZIONE FATTURE PASSIVE 
                <label class="roboSubTitle" [ngClass]="utente.mod_ric_fp=='' ? 'colorRed': ''">{{
                    'users.editor.receivingMode' | translate }}</label>

                <app-select class="selectDm7" [options]="recWays" [key]="'key'" [value]="'value'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.mod_ric_fp"
                    (change)="utente.mod_ric_fp = $event.key;setCodiceUnivoco()"
                    [valClass]="utente.mod_ric_fp=='' ? 'borderRed': ''"></app-select>
            </div>
        </ng-container>-->

        <!--<div [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             CODICE UNIVOCO 
            <label class="roboSubTitle"
                [ngClass]="(utente.mod_ric_fp=='C' && (utente.codice_univoco== undefined || utente.codice_univoco.length==0)) ?'colorRed':''">{{
                'users.editor.uCode' | translate }}</label>
            <input class="form-control" type="text" [(ngModel)]="utente.codice_univoco" maxlength="7"
                oninput="javascript:this.value = this.value.toLocaleUpperCase(); if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                [ngClass]="(utente.mod_ric_fp=='C' && (utente.codice_univoco== undefined || utente.codice_univoco.length==0)) ?'borderRed':''">
        </div>
    </div>-->
    <!--<div class="row mt-2">
        <div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             EMAIL PEC  
            <label class="roboSubTitle"
                [ngClass]="utente.mod_ric_fp=='P' && utente.email_pec.length==0 ?'colorRed':''">Email
                PEC</label>
            <input class="form-control" type="text" [(ngModel)]="utente.email_pec"
                [ngClass]="utente.mod_ric_fp=='P' && utente.email_pec.length==0 ?'borderRed':''">
        </div>
        <div [ngClass]="{'col-2' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                PASSWORD PEC  
            <label class="roboSubTitle"
                [ngClass]="(utente.mod_ric_fp=='P' && (utente.password_pec== undefined || utente.password_pec.length==0)) ?'colorRed':''">Password
                PEC</label>
            <input class="form-control" [type]="passwordFieldType" id="password-field"
                [(ngModel)]="utente.password_pec" [disabled]="utente.email_pec.length==0"
                [ngClass]="(utente.mod_ric_fp=='P' && (utente.password_pec== undefined || utente.password_pec.length==0)) ?'borderRed':''">
            <span toggle="#password-field" class="bi field-icon toggle-password" (click)="changeVisibility()"
                [ngClass]="{'bi-eye-slash-fill' : hidePw, 'bi-eye-fill' : !hidePw}"></span>
        </div>
    </div>-->
    <!--<div class="row" style="margin-top:20px">
        <div [ngClass]="{'col-4' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             EMAIL notifiche fatturazione passiva  
            <label class="roboSubTitle">{{ 'users.editor.email_passiva' | translate }}</label>
            <input class="form-control" type="text" [ngbTooltip]="'users.editor.tooltip2' | translate"
                [(ngModel)]="utente.email_passiva">
        </div>-->
        <!--<div [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             EMAIL notifiche ricezione ordini  
            <label class="roboSubTitle">{{ 'users.editor.email_ordini' | translate }}</label>
            <input class="form-control" type="text" [ngbTooltip]="'users.editor.tooltip3' | translate"
                [(ngModel)]="utente.email_ricezione_ordini">
        </div>
    </div>

    <div class="row mt-2" *ngIf="utente.id !='' && (me!.role =='A' || me!.role=='S')">
        <div class="col-12 col-sm-8 col-md-6 col-lg-3"
            *ngIf="utente.codice_univoco != '' || utente.email_pec != ''">
            <label class="roboSubTitle">{{ 'users.editor.disable_passive' | translate}}</label>
            <button type="button" class="btn btn-danger form-control" (click)='disabilitaFatturazionePassiva()'> <i
                    class="bi bi-stop-fill"></i> {{ 'users.editor.disable_passive' | translate}}</button>
        </div>
    </div>-->



    <!--<hr>
    <div class="row" style="margin-top:20px">
        <div class="actionBar">
            <h5 class="roboSubTitle col" style="text-transform: uppercase;">DATI AZIENDA</h5>
            <div class="custom-control custom-switch text-right" (click)="easyMode=!easyMode">
                <input type="checkbox" [checked]="easyMode" class="custom-control-input">
                <label class="custom-control-label" for="">{{ (easyMode ?
                    'users.personal.easyModeTrue':'users.personal.easyModeFalse') | translate}}</label>
            </div>
        </div>
    </div>
    <div class="row" style="margin-top:20px">

        <div *ngIf='utente.dms_api_url'
            [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
             AZIENDA
            <label class="roboSubTitle">{{'users.editor.company' | translate}}</label>

            <div *ngIf="utente.id == ''" class="input-group" style="flex: 1">
                <input id="btnPass" id="btnPassEnv" type="text" class="form-control"
                    [(ngModel)]="utente.dms_company" [placeholder]="'placeholder.search' | translate" disabled />
                <span class="input-group-text" id="basic-addon1" (click)="ricercaAzienda()">
                    <i class="bi bi-search" [ngbTooltip]="'configuration.rubrica.search' | translate"></i>
                </span>
            </div>
            <div *ngIf="utente.id !== ''" class="input-group" style="flex: 1">
                <input id="btnPass" id="btnPassEnv" type="text" class="form-control"
                    [(ngModel)]="utente.dms_company!.name" [placeholder]="'placeholder.search' | translate"
                    disabled />
            </div>
        </div>
        <div *ngIf='utente.dms_api_url && utente.id == ""' class="col-2">
            <label class="roboSubTitle">{{ 'users.editor.companyCreate' | translate}}</label>
            <button type="button" class="btn btn-success form-control" (click)='openModalAzienda()'><i
                    class="bi bi-plus-circle"></i> {{ 'users.editor.companyCreate' | translate}}</button>
        </div>
    </div>


     CHECK CREDENZIALI DI FIRMA
    <div class="mt-2" *ngIf="!easyMode || modifySig"
        [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
        class="form-group form-check" style="margin-bottom: 5px; margin-top: 10px">
        <div>
            <input type="checkbox" class="form-check-input" [(ngModel)]='modifySig'>
            <label class="form-check-label">{{'users.editor.credentials' | translate}}</label>
        </div>

    </div>

    <ng-container *ngIf="modifySig">
        <div class="row" style="margin-top:20px">
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 USERNAME FIRMA ELETTRONICA  
                <label class="roboSubTitle">{{ 'users.editor.firma_username' | translate }}</label>
                <input class="form-control" type="text" [(ngModel)]="utente.firma_username">
            </div>
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 PASSWORD FIRMA ELETTRONICA 
                <label class="roboSubTitle">{{ 'users.editor.firma_password' | translate }}</label>
                <input class="form-control" type="password" [(ngModel)]="utente.firma_password">
            </div>

        </div>
        <hr>
    </ng-container>

     MODIFICA DATI DM7 
    <ng-container *ngIf="(id!='new') && (!easyMode || modifyDM7)">
        <div [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
            class="form-group form-check" style="margin-bottom: 5px;">
            <div>
                <input type="checkbox" class="form-check-input" [(ngModel)]="modifyDM7">
                <label class="form-check-label">{{'users.editor.modifyDM7' | translate}}</label>
            </div>
        </div>

    </ng-container>

     DATI DOCUMENTALE DM7  
    <ng-container *ngIf="(!easyMode && modifyDM7) || ( ( id=='new' && !easyMode )|| (modifyDM7 && id!='new'))">
        <div class="actionBar">
            <h6 class="col roboSubTitle" style="margin-top: 20px; margin-bottom: -20px;">{{ 'users.editor.dm7Title' |
                translate }}<br *ngIf="innerWidth! <= 767"></h6>
        </div>

        <div class="row" style="margin-bottom:20px">
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 IDENTIFICATIVO TIPOLOGIA FATTURA 
                <label class="roboSubTitle">{{ 'users.editor.dms_einvoice_type_id' | translate }}</label>
                <app-select class="selectDm7"
                    [disabled]="(me!.role != 'S' && me!.role != 'A' && utente.dms_einvoice_type_id != '' && utente.id != '')"
                    [options]="getValues(doctypes, 'nomeType','Fattura Elettronica Attiva')" [key]="'idType'"
                    [value]="'nomeType'" [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_einvoice_type_id"
                    (change)="utente.dms_einvoice_type_id = $event.key;">
                </app-select>
            </div>

            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                IDENTIFICATIVO WORKFLOW FATTURA 
                <label class="roboSubTitle">{{ 'users.editor.dms_einvoice_workflow_id' | translate }}</label>
                <app-select class="selectDm7"
                    [disabled]="(me!.role != 'S' && me!.role != 'A' && utente.dms_einvoice_workflow_id != '' && utente.id != '')"
                    [options]="getValues(wfType, 'nomeWf','Fatturazione Elettronica Attiva')" [key]="'idWf'"
                    [value]="'nomeWf'" [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_einvoice_workflow_id"
                    (change)="utente.dms_einvoice_workflow_id = $event.key;">
                </app-select>
            </div>


            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 Identificativo tipologia fattura passiva 
                <label class="roboSubTitle">{{ 'users.editor.dms_einvoicep_type_id' | translate }}</label>
                <app-select class="selectDm7"
                    [disabled]="(me!.role != 'S' && me!.role != 'A' && utente.dms_einvoicep_type_id != '' && utente.id != '')"
                    [options]="getValues(doctypes, 'nomeType','Fattura Elettronica Passiva')" [key]="'idType'"
                    [value]="'nomeType'" [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_einvoicep_type_id"
                    (change)="utente.dms_einvoicep_type_id = $event.key; eventChangeRole($event.key)"></app-select>
            </div>
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 Identificativo workflow fattura passiva 
                <label class="roboSubTitle">{{ 'users.editor.dms_einvoice_workflowp_id' | translate }}</label>
                <app-select class="selectDm7"
                    [disabled]="(me!.role != 'S' && me!.role != 'A' && utente.dms_einvoice_workflowp_id != '' && utente.id != '')"
                    [options]="getValues(wfType, 'nomeWf','Fatturazione Elettronica Passiva')" [key]="'idWf'"
                    [value]="'nomeWf'" [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_einvoice_workflowp_id"
                    (change)="utente.dms_einvoice_workflowp_id = $event.key; eventChangeRole($event.key)"></app-select>
            </div>

        </div>
        <hr>
    </ng-container>
     ATTIVA GESTIONE FATTURE UBL SU PEPPOL 
    <div *ngIf="(utente.abilita_peppol || !easyMode)"
        [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
        class="form-group form-check" style="margin-bottom: 5px;">
        <div>
            <input type="checkbox" class="form-check-input" [(ngModel)]='utente.abilita_peppol'>
            <label class="form-check-label">{{'users.editor.peppol' | translate}}</label>
        </div>
    </div>
    <ng-container *ngIf="utente.abilita_peppol">
        <div class="actionBar">
            <h5 class="roboSubTitle col" style="margin-top: 20px; margin-bottom: -20px;">{{ 'users.editor.fattUBLTitle'
                | translate }}<br *ngIf="innerWidth! <= 767"></h5>
        </div>

        <div class="row">
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                Identificativo tipologia fattura ATTIVA 
                <label class="roboSubTitle">{{ 'users.editor.fattura_ubl_attiva' | translate }}</label>
                <app-select class="selectDm7" [options]="doctypes" [key]="'idType'" [value]="'nomeType'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_fattura_ubl_attiva_id"
                    (change)="utente.dms_fattura_ubl_attiva_id = $event.key;"></app-select>
            </div>
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 Identificativo tipologia fattura passiva 
                <label class="roboSubTitle">{{ 'users.editor.fattura_ubl_passiva' | translate }}</label>
                <app-select class="selectDm7" [options]="doctypes" [key]="'idType'" [value]="'nomeType'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_fattura_ubl_passiva_id"
                    (change)="utente.dms_fattura_ubl_passiva_id = $event.key; "></app-select>
            </div>

        </div>
        <hr>
    </ng-container>

     ATTIVA GESTIONE DDT UBL SU PEPPOL 
    <div *ngIf="(utente.abilita_ddt || !easyMode)"
        [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
        class="form-group form-check" style="margin-bottom: 5px;">
        <div>
            <input type="checkbox" class="form-check-input" [(ngModel)]='utente.abilita_ddt'>
            <label class="form-check-label">{{'users.editor.ddt' | translate}}</label>
        </div>
    </div>
    <ng-container *ngIf="utente.abilita_ddt">
        <div class="actionBar">
            <h5 class="roboSubTitle col" style="margin-top: 20px; margin-bottom: -20px;">{{ 'users.editor.ddtUBLTitle'
                | translate }}<br *ngIf="innerWidth! <= 767"></h5>
        </div>

        <div class="row">
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 Identificativo tipologia ddt passiva 
                <label class="roboSubTitle">{{ 'users.editor.ddt_ubl_attiva' | translate }}</label>
                <app-select class="selectDm7" [options]="doctypes" [key]="'idType'" [value]="'nomeType'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_ddt_attiva_id"
                    (change)="utente.dms_ddt_attiva_id = $event.key;"></app-select>
            </div>
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                Identificativo tipologia ddt passiva 
                <label class="roboSubTitle">{{ 'users.editor.ddt_ubl_passiva' | translate }}</label>
                <app-select class="selectDm7" [options]="doctypes" [key]="'idType'" [value]="'nomeType'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_ddt_passiva_id"
                    (change)="utente.dms_ddt_passiva_id = $event.key; "></app-select>
            </div>

        </div>
        <hr>
    </ng-container>

     ATTIVA GESTIONE ORDINI UBL SU NSO 
    <div *ngIf="(utente.abilita_nso || !easyMode)"
        [ngClass]="{'col-6' : innerWidth! > 767, 'col-12': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}"
        class="form-group form-check" style="margin-bottom: 5px;">
        <div>
            <input type="checkbox" class="form-check-input" [(ngModel)]='utente.abilita_nso'>
            <label class="form-check-label">{{'users.editor.nso' | translate}}</label>
        </div>
    </div>
    <ng-container *ngIf="utente.abilita_nso">
        <div class="actionBar">
            <h5 class="roboSubTitle col" style="margin-top: 20px; margin-bottom: -20px;">{{ 'users.editor.ordUBLTitle' |
                translate }}<br *ngIf="innerWidth! <= 767"></h5>
        </div>
        <div class="row">
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 Identificativo tipologia ORDINI RICEVUTI 
                <label class="roboSubTitle">{{ 'users.editor.ordini_ricevuti' | translate }}</label>
                <app-select class="selectDm7" [options]="doctypes" [key]="'idType'" [value]="'nomeType'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_ordini_ricevuti_id"
                    (change)="utente.dms_ordini_ricevuti_id = $event.key;"></app-select>
            </div>
            <div
                [ngClass]="{'col-3' : innerWidth! > 767, 'col-6': innerWidth! <= 767, 'margin-top5': innerWidth! <= 767}">
                 Identificativo tipologia ORDINI INVIATI 
                <label class="roboSubTitle">{{ 'users.editor.ordini_inviati' | translate }}</label>
                <app-select class="selectDm7" [options]="doctypes" [key]="'idType'" [value]="'nomeType'"
                    [placeholder]="'placeholder.select' | translate" [addNull]="false"
                    [selectedKey]="utente.dms_ordini_inviati_id"
                    (change)="utente.dms_ordini_inviati_id = $event.key;"></app-select>
            </div>

        </div>
    </ng-container>
    <hr>
    <app-personal-data *ngIf="utente.json_sdi_data" #pdc [json_sdi_data]='utente.json_sdi_data'
        (change)='setJsonData($event)'></app-personal-data>-->





</ng-container>
<ng-template #waiting>
    <app-loading></app-loading>
</ng-template>
<router-outlet></router-outlet>
